import { BrowserRouter } from 'react-router-dom'
import { createTheme, ThemeProvider } from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { InitReqProvider } from './InitReq'
import { SettingsProvider } from './Settings'
import { CategoryProvider } from './Categories'
import { PlanProvider } from './Plans'
import { FormProvider } from './Form'
import { NotificationProvider } from './Notification'
import { I18nProvider } from './i18n'
import Layout from './layouts'
import Maintenance from './Maintenance'

const theme = createTheme({
  typography: {
    fontFamily: "'Poppins', 'Roboto', 'Helvetica', 'Arial', sans-serif",
    h1: { fontFamily: "'Poppins', sans-serif" },
    h2: { fontFamily: "'Poppins', sans-serif" },
    h3: { fontFamily: "'Poppins', sans-serif" },
    body1: { fontFamily: "'Poppins', sans-serif" },
    body2: { fontFamily: "'Poppins', sans-serif" }
  }
})

const maintenance = false

function App() {
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <I18nProvider>
          <SettingsProvider>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <NotificationProvider>
                <FormProvider>
                  <InitReqProvider>
                    <CategoryProvider>
                      <PlanProvider>
                        {maintenance ? <Maintenance /> : <Layout />}
                      </PlanProvider>
                    </CategoryProvider>
                  </InitReqProvider>
                </FormProvider>
              </NotificationProvider>
            </LocalizationProvider>
          </SettingsProvider>
        </I18nProvider>
      </BrowserRouter>
    </ThemeProvider>
  )
}

export default App